import axios from "axios";
import Cookies from "../components/cookies";
import config from "../config";


const handleExpiredToken = () => {
    window.location = "/";
}


export const OrganizationDetails = async (company_id) =>{
    
    
    const CookieObj = new Cookies();
    let access_token = CookieObj.getCookie("token")
    var organization_details = [];
    axios.defaults.baseURL = config.servers["base"];
    let urlTOload = `company/${company_id}/get/`
    
    await axios.get(
        urlTOload,
        {
            headers:{
                authorization : "Bearer " + access_token 
            }
        }
    ).then((response)=>{
        if(response.status === 401){
            handleExpiredToken();
        }
        organization_details = response.data;
        
        

    }).catch(error=>{
        if(error.response.status === 401)
        {   
            handleExpiredToken();
        }
        else{
            organization_details = [] 
        }
    })
    return await organization_details

}